import React from 'react';

const ModalFunnelMixin = {
  componentWillMount() {
    this.modalCboxOpen = false;
  },
  modal(url, params, callbacks) {
    if (params && Object.keys(params).length != 0) {
      const paramStr = Object.keys(params)
        .map(k => {
          return `${k}=${params[k]}`;
        })
        .join('&');
      url += `&${paramStr}`;
    }
    const cboxOptions = callbacks;
    cboxOptions.href = url;
    if (typeof $ !== 'undefined' && this.modalCboxOpen == false) {
      this.modalCboxOpen = true;
      $.colorbox(cboxOptions);
      $(window).on('resize', () => {
        if (window.innerWidth <= 767 && this.modalCboxOpen) {
          this.closeModal();
        }
      });
    }
  },
  closeModal() {
    $.colorbox.close();
    this.modalCboxOpen = false;
  },
  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },
  modalSignup(closeCallback, ref, returnTo) {
    window.onbeforeunload = null; // remove prompts before leaving page

    const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const inIframe = this.inIframe();
    // If on mobile or in iframe always go to full page
    if ((isMobile || inIframe) && window && window.top) {
      window.top.location = window.checkLinkAndAppendLanguage(`/signup?returnTo=${returnTo}&ref=${ref}`);
      return false;
    }
    if (window) window.location = window.checkLinkAndAppendLanguage(`/signup?returnTo=${returnTo}&ref=${ref}`);
    return false;
  },
  modalPro(closeCallback, ref, returnTo) {
    window.onbeforeunload = null; // remove prompts before leaving page

    const isMobile = typeof navigator !== 'undefined' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const inIframe = this.inIframe();
    // If on mobile or in iframe always go to full page
    if ((isMobile || inIframe) && window && window.top) {
      window.top.location = window.checkLinkAndAppendLanguage(`/pro?returnTo=${returnTo}&ref=${ref}`);
      return false;
    }
    if (window && window.top) {
      window.top.location.href = window.checkLinkAndAppendLanguage(`/pro?returnTo=${returnTo}&ref=${ref}`);
    }
  }
};

export { ModalFunnelMixin };
